export const cheatsheetViewPage = () =>
  import("./CheatsheetViewPage").then((m) => ({ Component: m.CheatsheetViewPage }));
